import { HttpErrorResponse } from '@angular/common/http';
import { GetSessionFromPaymentLinkV1Response } from '@arc/unified-payments-frontend/shared-payment';
import { createAction, props } from '@ngrx/store';

export const exchangeTokenForSessionSuccess = createAction(
  '[Payment Link Landing Component - Payment Link] Exchange Token For Session Success',
  props<{ response: GetSessionFromPaymentLinkV1Response }>(),
);

export const exchangeTokenForSessionError = createAction(
  '[Payment Link Landing Component - Payment Link] Exchange Token For Session Error',
  props<{ error: HttpErrorResponse }>(),
);
